import React from 'react'
import Title from "../../components/atoms/Title";
import ButtonT from "../../components/atoms/ButtonT";
import Button from "../../components/atoms/Button";

const DevicedetailHeadet = ({name, status, actionlog, onDelete, onDeleteBroker, text, barcodeAddress}) => {
    return (<div className="flex flex-row justify-between items-center h-10 ">
        <div className="flex flex-row">
            <Title text={text ? `جزئیات ${text} “${name}”` : `جزئیات سفارش “${name}”`}/>

        </div>

        <div className="flex flex-row gap-3.5">
            <a
                href={barcodeAddress}
                className={`
                    border-solid flex items-center px-3.5 py-2.5 text-dark-blue-200
                    font-normal text-12 rounded-sm leading-5.4 gap-2.2 h-10 border-blue border-1`}>
                دانلود بارکد
            </a>
            <Button text={"تاریخچه فعالیت"} borderBlue="border-blue border-1" textcolor={" text-dark-blue-200"}
                    onClick={actionlog}/>
            <Button text={"حذف از بروکر"} borderBlue="border-red border-1" textcolor={"text-red "}
                    onClick={onDeleteBroker}/>
            <Button text={"حذف دستگاه"} borderBlue="border-red border-1" textcolor={"text-red "}
                    onClick={onDelete}/>
            <ButtonT text={"برگشت به لیست"} path={"/admin/device/list"} link={true}/>
        </div>

    </div>)
}

export default DevicedetailHeadet
